<template>
  <form @submit.prevent="submit" novalidate="true">
    <b-card>
      <div class="form-row mt-1">
        <div class="col-1 ml-auto" v-bind:class="{ inlineSpinner: isBusy }"></div>
      </div>

      <div v-if="localUserProfile">
        <b-form-group :label-cols-sm="2" :label="$t('Webportal.Name')" label-class="font-weight-bold"
                      :disabled="true">
          <div class="form-row">
            <div class="col-auto">
              <b-form-input v-model="localUserProfile.FirstName"></b-form-input>
            </div>
            <div class="col-auto">
              <b-form-input v-model="localUserProfile.LastName"></b-form-input>
            </div>
          </div>
        </b-form-group>

        <b-form-group :label-cols-sm="2" :label="$t('Webportal.EmailAddress')" label-class="font-weight-bold"
                      :disabled="true">
          <b-form-input v-model="localUserProfile.Email"></b-form-input>
        </b-form-group>
      </div>

      <template slot="footer">
        <div class="float-right">
          <button @click.prevent="cancel" class="btn btn-secondary" :disabled="!isFormDirty || isBusy">
            <font-awesome-icon :icon="['far', 'ban']" /> {{ $t('Webportal.Cancel') }}
          </button>
          <button type="submit" class="btn btn-primary" :disabled="!isFormDirty || !isFormValid || isBusy">
            <font-awesome-icon :icon="['far', 'dot-circle']" /> {{ $t('Webportal.Save') }}
          </button>
        </div>
      </template>
    </b-card>
  </form>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import AuthenticationService from '@/services/AuthenticationService';

export default {
  name: "UserProfile",

  mixins: [ AppConfig ],

  data () {
    return {
      profileSettings: null,

      isBusy: false
    }
  },

  computed: {
    isFormDirty() {
      return Object.keys(this.validationFields).some(key => this.validationFields[key].dirty);
    },
    
    isFormValid() {
      return Object.keys(this.validationFields).every(key => this.validationFields[key].valid === null || this.validationFields[key].valid);
    },

    localUserProfile: function() {
      return AuthenticationService.localUserProfile;
    },
  },

  activated() {
    this.getProfileSettings();
  },

  beforeRouteLeave (to, from, next) {
    this.$emit('unsavedChanges', this.isFormDirty, next);
  },

  methods: {
    getProfileSettings() {
      // AdministationService.getProfileSettings()
      //   .then(response => {
      //     this.isBusy = false;

      //     this.profileSettings = response.data ? response.data[0] : null;
      //     this.$validator.reset();
      //   });
    },

    cancel() {
      this.$emit('unsavedChanges', this.isFormDirty, result => {
        if (result !== false) this.getProfileSettings();
      });
    },

    submit() {
      this.isBusy = true;

      // AdministationService.setProfileSettings(this.profileSettings)
      //   .then(response => {
      //     this.isBusy = false;
      //     this.$validator.reset();
      //   })
      //   .catch(_ => { this.isBusy = false; } );
    }
  }
}
</script>
